export default "__VITE_ASSET__CRaegtPl__"